import { Component, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from '../../services/http.service';
import { AuthenService } from '../../services/authen.service';
import { HelperService } from '../../services/helper.service';

@Component({
    selector: 'hs-matrix-edit',
    templateUrl: './hs-matrix-edit.html',
})
export class HSMatrixEditComponent implements OnInit {
    subs: any = null;
    id: number = 0;
    item: any = null;
    requestTypeIdSelected: number = null;
    requestTypeList: any[] = [];
    nameValueFields: Object = { text: 'Name', value: 'Value' };    

    constructor(private http: HttpService, private auth: AuthenService, private route: ActivatedRoute, private helper: HelperService) {
        this.subs = route.params.subscribe(params => {
            this.id = params['id'];
        })
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }

    ngOnInit() {
        this.http.get('api/Util/GetAllRequestTypeList/', res => {
            this.requestTypeList = res.Result;
            if (this.id > 0)
                this.load(this.id);
        }, null);        
    }

    load(id: number) {
        this.http.get(`api/Util/GetHSMatrix/${id}`, res => {
            this.item = res.Result;
            this.requestTypeIdSelected = this.item.GroupRequestId;
        });
    }

    isInputValid() {
        let msg = null;
        if (this.item.HSUserCode == null) {
            msg = 'HS user code is required'
        }

        return msg;
    }

    onSave() {
        let err = this.isInputValid();
        if (err == null) {
            this.item.GroupRequestId = this.requestTypeIdSelected;
            this.http.save('api/Util/SaveHSMatrix', this.item, res => {
            });
        } else {
            this.helper.alertFailed(err);
        }
    }
}
